import React from 'react';
import { useTranslation } from 'react-i18next';
import { canAccessFeature } from '../utils/planAccess';
import Modal from './Modal';
import UpgradeCta from './UpgradeCta';

function TaskDraftModal({
  isOpen,
  onClose,
  editingDraftId,
  draftFormData,
  setDraftFormData,
  setDraftBannerFile,
  draftBannerInputRef,
  onSubmit,
  user
}) {
  const { t } = useTranslation(['tasks', 'common']);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editingDraftId ? t('tasks:editDraftTitle') : t('tasks:submitTaskDraftTitle')}
    >
      <form onSubmit={onSubmit}>
            <div className="form-group">
              <label>{t('tasks:titleLabel')}</label>
              <input
                type="text"
                value={draftFormData.title}
                onChange={(e) => setDraftFormData({ ...draftFormData, title: e.target.value })}
                required
              />
            </div>
            <div className="form-group">
              <label>{t('tasks:descriptionLabel')}</label>
              <textarea
                value={draftFormData.description}
                onChange={(e) => setDraftFormData({ ...draftFormData, description: e.target.value })}
              />
            </div>
            <div className="form-group">
              <label>{t('tasks:bannerImageLabel')}</label>
              {canAccessFeature(user, 'taskImageUploads') ? (
                <input
                  type="file"
                  accept="image/*"
                  ref={draftBannerInputRef}
                  onChange={(e) =>
                    setDraftBannerFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)
                  }
                />
              ) : (
                <UpgradeCta as="small" />
              )}
            </div>
            <div className="modal-actions">
              <button type="submit" className="btn btn-primary">
                {editingDraftId ? t('tasks:saveDraft') : t('tasks:submitDraft')}
              </button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                {t('common:cancel')}
              </button>
            </div>
          </form>
    </Modal>
  );
}

export default TaskDraftModal;
